module.exports = __webpack_public_path__ + "resources/img/img_datahunt6_m_en.d055fc3764fde188069ddc96991e0293.png";